// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nI-z","twoColumnImage":"oI-z"};